"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _linkFieldSrc = require("../lib/linkFieldSrc");
var _richTextField = require("../lib/richTextField");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _lodash = require("lodash");
var _titleHeadTag = require("../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Renders the Horizontal Card with links
 *
 * @param {object} props sitecore fields Properties used to render the link list
 *
 * @returns {React.ReactElement} A horizontal card element
 */

var CardWithLinkList = props => {
  var CardTitle = props => {
    var titleSize = (0, _lodash.isEmpty)(props.TitleSize.value) ? 'h4' : props.TitleSize.value;
    return (0, _titleHeadTag.headTagTitle)(props.Title, 'card-title', titleSize);
  };
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: props.fields.Variant.value
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, !(0, _lodash.isEmpty)(props.fields.Title.value) && /*#__PURE__*/_react.default.createElement(CardTitle, props.fields), !(0, _lodash.isEmpty)(props.fields.Eyebrow.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, props.fields.Eyebrow.value), !(0, _lodash.isEmpty)(props.fields.PreviewText.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Text, null, /*#__PURE__*/_react.default.createElement("p", null, (0, _richTextField.parseHTML)(props.fields.PreviewText))), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled"
  }, props.fields.LinkList.map(links => {
    var {
      linkUrl,
      linkTarget,
      linkAlt
    } = (0, _linkFieldSrc.linkFieldSrc)(links.fields.Link.value);
    var iconClass = props.fields.Variant.value.includes('dark') ? links.fields.Icon.value + '-white' : links.fields.Icon.value;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: links.id
    }, !(0, _lodash.isEmpty)(links.fields.Icon.value) && /*#__PURE__*/_react.default.createElement("span", {
      className: iconClass
    }), ' ', /*#__PURE__*/_react.default.createElement("a", {
      href: linkUrl,
      target: linkTarget,
      title: linkAlt
    }, links.fields.LinkLabel.value), ' ', /*#__PURE__*/_react.default.createElement("span", {
      className: "caption"
    }, links.fields.DocumentType.value ? "(".concat(links.fields.DocumentType.value, ")") : undefined));
  }))));
};
var _default = exports.default = CardWithLinkList;